module.exports = __webpack_public_path__ + "static/media/hamburger.8299b6bf.svg";